// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"NewsList_titleWrapper__RcbTC","filters":"NewsList_filters__DIh6o","list":"NewsList_list__a1chi"};